import React from 'react';
import { Phone, Mail, MapPin, ChevronRight } from 'lucide-react';
import { companyInfo } from '../data/mock';
import Logo from './Logo';

const Footer = () => {
  const quickLinks = [
    { label: 'About Us', href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Industries', href: '#industries' },
    { label: 'Blog', href: '#blog' },
    { label: 'Contact Us', href: '#contact' }
  ];

  const services = [
    'Cybersecurity Solutions',
    'IT Infrastructure Management',
    'Managed Services',
    'Cloud Architecture',
    'Business Communications'
  ];

  return (
    <footer className="bg-[#0a2342] text-white">
      {/* Quote Banner */}
      <div className="border-b border-white/10 py-12">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <p className="text-lg md:text-xl text-white/80 italic leading-relaxed">
            "Technology leadership requires more than technical expertise—it demands strategic vision, operational excellence, and an unwavering commitment to security. We partner with organizations to transform IT from a cost center into a competitive advantage."
          </p>
          <a
            href="#contact"
            className="inline-block mt-6 px-8 py-3.5 bg-[#0077B6] text-white font-semibold rounded-full hover:bg-[#005f8f] transition-colors"
          >
            Start Your Consultation
          </a>
        </div>
      </div>

      {/* Main Footer */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Company Info */}
            <div>
              <div className="mb-6">
                <Logo variant="light" />
              </div>
              <p className="text-white/70 text-sm mb-6 leading-relaxed">
                A trusted technology partner delivering enterprise IT solutions and cybersecurity services to organizations across Ontario since {companyInfo.established}.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-bold text-lg mb-6">Quick Links</h4>
              <ul className="space-y-3">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className="text-white/70 hover:text-[#D4AF37] transition-colors flex items-center gap-2 text-sm">
                      <ChevronRight size={14} />
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-bold text-lg mb-6">Our Services</h4>
              <ul className="space-y-3">
                {services.map((service, index) => (
                  <li key={index}>
                    <a href="#services" className="text-white/70 hover:text-[#D4AF37] transition-colors flex items-center gap-2 text-sm">
                      <ChevronRight size={14} />
                      {service}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-bold text-lg mb-6">Contact Us</h4>
              <ul className="space-y-4">
                <li>
                  <a href={`tel:${companyInfo.phone.support}`} className="flex items-start gap-3 text-white/70 hover:text-[#0077B6] transition-colors text-sm">
                    <Phone size={18} className="flex-shrink-0 mt-0.5" />
                    <div>
                      <div>Support: {companyInfo.phone.support}</div>
                    </div>
                  </a>
                </li>
                <li>
                  <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-3 text-white/70 hover:text-[#0077B6] transition-colors text-sm">
                    <Mail size={18} className="flex-shrink-0" />
                    {companyInfo.email}
                  </a>
                </li>
                <li className="flex items-start gap-3 text-white/70 text-sm">
                  <MapPin size={18} className="flex-shrink-0 mt-0.5" />
                  <span>{companyInfo.location}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/10 py-6">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/60">
            <p>© {new Date().getFullYear()} {companyInfo.name}. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-white transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
